///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportProductCategory = Meevo.Plugins.Reports.IReportProductCategory;

    export class ReportProductCategoryCollection extends SmartMoverApiCollection<IReportProductCategory> implements IApiCollection<IReportProductCategory> {

        protected get smartMoverHiddenValue() {
            return this.options.hiddenValue || SmartMoverHiddenValue.EmptyArray;
        }

        protected get url() {
            return 'report/ProductCategory';
        }

    }
}